import axiosClient from "./api-handlers";
import mheaaxiosClient from "./api-mheaHandlers"
import {aggregatorType, apitoken, groupId, hospitalgroupId, opdEmr, mheaUrl, is_group_exist} from "../utils/constant";
import opdEmraxiosClient from "./api-OPDEMRHandlers";
// Dev
// const JWT = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvZGV2LmFwcGFwaXMuZGVza3RvcC5teWhlYWx0aGNhcmUuY28iLCJpYXQiOjE2NTMzNzE4ODMsIm5iZiI6MTY1MzM3MTg4MywiZXhwIjoxNjU1OTYzODgzLCJ1aWQiOjI4NzE5MCwidCI6InAifQ.Na1rtEcGdv9Lh2iMhxXkd3UTQuj3lIBhIws_wp1sxx4';
// Prod
//const JWT = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvbWhhcHBhcGlzLnZjLm15aGVhbHRoY2FyZS5jb1wvIiwiaWF0IjoxNjU1MTIyNDA2LCJuYmYiOjE2NTUxMjI0MDYsImV4cCI6MTY2Mjg5ODQwNiwidWlkIjoxMjA0NiwidCI6InAifQ.p4BvxAGqHhpgwybAkvjUQT1AmP0Sqrp5S7qCur9gftc';

export async function appointmentCall(current_page, startDate, endDate, isFamilyMember, JWT) {
  //&hospital_group_id=1
  let date = '';
  if(startDate != null && endDate !=null){
      date = `&start_date=${startDate}&end_date=${endDate}`
  }
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  }
  const response = await axiosClient.get(
    `/patients/web/v2/patients/appointments?type=all${date}&page=${current_page}${isFamilyMember}${group_exist}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}
//delete image in dector consult

export async function deletDectorConsult(id, JWT) {
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  }
  const response = await axiosClient.post(
    `patients/ios/v2/doctors/delete-documents/${id}${group_exist}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}
///Add Notes/ Documents


export async function addNotesDocuments(payload, id, JWT) {
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  }
  const response = await axiosClient.post(
    `/patients/web/v2/doctors/upload-documents/${id}${group_exist}`,
    payload,
    {
      "mimeType": "multipart/form-data",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  
  return response;
}


/// show add not details
export async function addNotesDetails(id, JWT) {
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  }
  const response = await axiosClient.get(
    `/patients/ios/v2/doctors/appointment-status/${id}${group_exist}`,
  
    {
      "mimeType": "multipart/form-data",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  
  return response;
}

//delete image
export async function addNotesImgDelete(doc_id, JWT) {
  let payload = '';
  if(is_group_exist === true){
    payload ={'hospital_group_id':1, 'group_id':1}
  }
  const response = await axiosClient.post(
    `/patients/android/v2/doctors/delete-documents/${doc_id}`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

// sendFeedBack
export async function sendFeedBack(payload, JWT) {
  const response = await axiosClient.post(
    `/patients/android/v2/call`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
        aggregatorType: aggregatorType,
        apitoken: apitoken
      },
    }
  );
  return response;
}
/// booking
export async function cancelBookingReason(payload, JWT) {
  const response = await axiosClient.post(
    `/patients/android/v2/doctors/cancel-appointment`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
        aggregatorType: aggregatorType,
        apitoken: apitoken
      },
    }
  );
  return response;
}
// add My Prescriptions Order Test
export async function myPrescriptionsOrderTest(payload, JWT) {
  const response = await axiosClient.post(
    `/patients/web/v2/patients/diagnostic-orders-via-prescription`,
    payload,
    {
      "mimeType": "multipart/form-data",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  
  return response;
}

export async function homeCareCall(current_page, isFamilyMember, JWT) {
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  }
  const response = await axiosClient.get(
    `/patients/web/v2/tests/appointments?type=all&page=${current_page}${isFamilyMember}${group_exist}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}


export async function diagnosticsCall(current_page, isFamilyMember, JWT) {
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  }
  const response = await axiosClient.get(
    `/patients/web/v2/patients/throcare-appointment?page=${current_page}${isFamilyMember}${group_exist}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}


export async function diagnosticsShowDetails(booking_code, JWT) {
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  }
  const response = await axiosClient.get(
    `/patients/web/v2/patients/diagnostic-booking-showtestdetails?booking_code=${booking_code}${group_exist}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}


// For Diagnostic Parameters details
export async function diagnosticsParametersDetails(diagnosis_id, pincode) {
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  }  
  const response = await axiosClient.get(
    `/patients/web/v2/patients/thyrocare-test-Details?diagnosis_id=${diagnosis_id}&pincode=${pincode}${group_exist}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        aggregatorType: aggregatorType,
        apitoken: apitoken
      },
    }
  );
  return response;
}

// For Homecare Parameters details
export async function homecareParametersDetails(hospital_id, test_id) {
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  }   
  const response = await axiosClient.get(
    `/patients/android/v2/test/hospital_id/${hospital_id}/test/${test_id}${group_exist}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        aggregatorType: aggregatorType,
        apitoken: apitoken
      },
    }
  );
  return response;
}

export async function medicinesCall(current_page, isFamilyMember, JWT) {
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  }   
  const response = await axiosClient.get(
    `/patients/web/v2/patients/medicine-orders?page=${current_page}${isFamilyMember}${group_exist}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

///Medicine track order

export async function MedicineTrackOrder(order_id, vendor_id, contact_number, JWT) { 
  let payload = {'order_id':order_id, 'vendor_id': vendor_id, 'contact_number':contact_number, hospital_group_id:1, group_id:1}
  const response = await axiosClient.post(
    `/patients/android/v2/patients/track-order?order_id=${order_id}&vendor_id=${vendor_id}&contact_number=${contact_number}`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

///Diagnostic track order

export async function DiagnosticTrackOrder(book_code, JWT) { 
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  }   
  const response = await axiosClient.get(
    `/patients/web/v2/patients/throcare-appointment-tracking-order-status?booking_id=${book_code}${group_exist}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

////My Documents
export async function externalDocumentsCall(patient_id, current_page, category_id, JWT) {
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  } 
  const response = await axiosClient.get(
    `/patients/web/v2/getPhrDetails?patient_id=${patient_id}&page=${current_page}${category_id}${group_exist}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

///add Document externalDocument
export async function addExternalDocumentUpload(payload, JWT) {
  const response = await axiosClient.post(
    `/patients/ios/v2/uploadDocuments`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

// delete External Documents Data in my Document
export async function ExternalDataDelete(doc_id, JWT) {
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  }   
  const response = await axiosClient.get(
    `patients/android/v2/delete-record/${doc_id}${group_exist}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

export async function myAppointmentsCall(current_page, JWT) {
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  } 
  const response = await axiosClient.get(
    `/patients/web/v2/patients/appointments?type=all&is_documents=1&page=${current_page}${group_exist}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}
// myu Repoart
export async function myReportsCall(payload, JWT) { 
  const response = await mheaaxiosClient.post(
    `/LIS_RIS_Report/INV_ResultReportList`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
        aggregatorType: "opd_emr",
        apitoken: apitoken
      },
    }
  );
  return response;
}
// my Report Date Filter

export async function myReportsDateFilter(start_date, end_date, JWT) {
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  } 
  const response = await axiosClient.get(
    `/patients/android/v2/patients/throcare-report?start_date=${start_date}&end_date=${end_date}${group_exist}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

/// WalletHistory
export async function WalletHistoryCall(JWT) { 
  const response = await axiosClient.get(
    `/patients/web/v2/patients/wallet-history`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

// mybills
export async function PatientMyBillsCall(payload,JWT) {
    
  const response = await mheaaxiosClient.post(
    `/LIS_RIS_Report/InvInvoiceReportList`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
        aggregatorType: aggregatorType,
        apitoken: apitoken
      },
    }
  );
  return response;
}

// DischargeSummary
export async function myDischargeSummary(id,hospital_group_id, pageid, JWT) {
  const response = await opdEmraxiosClient.get(
    // `/ipdemr/discharge_patient_summary_status_patient_id/${id}?hospital_group_id=${hospital_group_id}?page=${pageid}&allow_pagination=Y`,
    `/ipdemr/discharge_patient_summary_status_patient_id/${id}?hospital_group_id=${hospital_group_id}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

export async function MemberProfileDelete(payload, JWT) {
  const response = await axiosClient.post(
    `/patients/web/v2/patients/family-members/delete`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

export async function MemberProfileEdit(payload, JWT) {
  console.log("payload", payload)
  const response = await axiosClient.post(
    `/patients/web/v2/patients/profile/update`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

//// myPrescription
export async function myPrescriptionHomecareCall(current_page, isFamilyMember, JWT) { 
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  } 
  const response = await axiosClient.get(
    `/patients/web/v2/patient-documents-by-hospital?is_homecare=1&page=${current_page}&family_member_id=${isFamilyMember}${group_exist}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

export async function myPrescriptionDocConsultCall(current_page, isFamilyMember, JWT) {
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  } 
  const response = await axiosClient.get(
    `/patients/web/v2/patient-documents-by-hospital?is_homecare=0&page=${current_page}&family_member_id=${isFamilyMember}${group_exist}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

/// order Track
export async function myPrescriptionTrackOrder(book_code, JWT) { 
  const response = await axiosClient.get(
    `/patients/web/v2/patients/throcare-appointment-tracking-order-status?booking_id=${book_code}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
      },
    }
  );
  return response;
}


// For Hospital State
export async function parasState() { 
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  }   
  const response = await axiosClient.get(
    `/patients/web/v2/patients/state?&country_id=1${group_exist}`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // Authorization: `${JWT}`,
      },
    }
  );
  return response;
}

// For Hospital City
export async function parasCity(id) { 
  let group_exist = '';
  if(is_group_exist === true){
    group_exist = `&hospital_group_id=${hospitalgroupId}&group_id=${groupId}`;
  }  
  const response = await axiosClient.get(
    `/patients/web/v2/patients/city?state_id=${id}${group_exist}`,    
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // Authorization: `${JWT}`,
      },
    }
  );
  return response;
}


export async function SendMedicinePrescription(payload, JWT) {
  const response = await axiosClient.post(
    `/patients/web/v2/patients/partner-diagnostic-orders-via-prescription`,
    payload,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `${JWT}`,
        aggregatorType: aggregatorType,
        apitoken: apitoken
      },
    }
  );
  return response;
}